// Route-level split between bizSAFE / SHMS jobs and client Internal Audit jobs. The job type is checked FIRST, so
// the bizSAFE JobDetail / AuditExecution (self-healing package render, ack tokens, COI…) never mount for an
// internal audit job.
import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'
import { isIA, isOTE } from '../lib/service'
import JobDetail from '../pages/JobDetail'
import AuditExecution from '../pages/AuditExecution'
import IAJobDetail from '../pages/IAJobDetail'
import OTEJobDetail from '../pages/OTEJobDetail'

function useJobType(id) {
  const [type, setType] = useState(undefined)   // undefined = loading, null = not found / no access
  useEffect(() => {
    let live = true
    setType(undefined)
    supabase.from('jobs').select('audit_type').eq('id', id).maybeSingle()
      .then(({ data }) => { if (live) setType(data ? (data.audit_type || '') : null) })
    return () => { live = false }
  }, [id])
  return type
}

// OTE jobs never open the bizSAFE or Internal Audit pages: the office gets the OTE job page, an auditor the OTE worksheet.

// /jobs/:id
export function JobRoute() {
  const { id } = useParams()
  const { isAuditor } = useAuth()
  const type = useJobType(id)
  if (type === undefined) return <div style={{ color: 'var(--text3)' }}>Loading…</div>
  if (type !== null && isOTE(type)) return isAuditor ? <Navigate to={`/jobs/${id}/ote`} replace /> : <OTEJobDetail />
  if (type !== null && isIA(type)) return isAuditor ? <Navigate to={`/jobs/${id}/ia`} replace /> : <IAJobDetail />
  return <JobDetail />
}

// /jobs/:id/execute
export function ExecuteRoute() {
  const { id } = useParams()
  const type = useJobType(id)
  if (type === undefined) return <div style={{ color: 'var(--text3)' }}>Loading…</div>
  if (type !== null && isOTE(type)) return <Navigate to={`/jobs/${id}/ote`} replace />
  if (type !== null && isIA(type)) return <Navigate to={`/jobs/${id}/ia`} replace />
  return <AuditExecution />
}
